import { jsxs as f, jsx as r } from "react/jsx-runtime";
import { t as l } from "../../bundle-mjs-DoW15_-f.js";
import { Tooltip as n } from "../Tooltip/index.js";
import { valueToggleTheme as t } from "./theme.js";
const v = ({
  options: i,
  value: c,
  onChange: b,
  className: g,
  disabled: a,
  compact: o,
  fullWidth: s
}) => {
  const u = i.findIndex((e) => e.value === c);
  return /* @__PURE__ */ f(
    "div",
    {
      className: l(
        t.root.base,
        o && t.root.compact,
        s && t.root.fullWidth,
        a && t.root.disabled,
        g
      ),
      children: [
        /* @__PURE__ */ r(
          "div",
          {
            className: l(
              t.indicator.base,
              o && t.indicator.compact,
              u === 0 ? t.indicator.off : t.indicator.on
            ),
            style: {
              width: `calc(50% - ${o ? "2px" : "4px"})`,
              transform: `translateX(${u}%)`
            }
          }
        ),
        i.map((e) => {
          const m = e.value === c, d = /* @__PURE__ */ r(
            "button",
            {
              type: "button",
              disabled: a,
              onClick: () => !m && !a && b(e.value),
              className: l(
                t.button.base,
                o && t.button.compact,
                s && t.button.fullWidth,
                m ? t.button.active.on : t.button.active.off
              ),
              children: e.label
            },
            String(e.value)
          );
          return e.tooltip ? /* @__PURE__ */ f(n, { children: [
            /* @__PURE__ */ r(n.Trigger, { asChild: !0, children: d }),
            /* @__PURE__ */ r(n.Content, { className: "tooltip-content-sm", children: e.tooltip })
          ] }, String(e.value)) : d;
        })
      ]
    }
  );
};
v.displayName = "ValueToggle";
export {
  v as ValueToggle
};
